/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }

(function() {
  let MENTIONS_ONLY = undefined;
  let MENTIONS_PATH = undefined;
  let MENTIONS_DIV_ID = undefined;
  let MENTIONS_INPUT_ID = undefined;
  const Cls = (Utility.TrixMentions = class TrixMentions {
    static initClass() {
      MENTIONS_ONLY = "mentions-only";
      MENTIONS_PATH = "mentions-path";
      MENTIONS_DIV_ID = "#trix-mentions-";
      MENTIONS_INPUT_ID = MENTIONS_DIV_ID + "input-";
    }

    static prepare($trix) {
      const mentionsDivForTrix = $trix => $(MENTIONS_DIV_ID + $trix.attr('trix-id'));

      const mentionsPositioningDivForTrix = $trix => mentionsDivForTrix($trix).find('.trix-mentions-position');

      const mentionsInputForTrix = $trix => $(MENTIONS_INPUT_ID + $trix.attr('trix-id'));

      const mentionsSelectizeForTrix = $trix => mentionsInputForTrix($trix).next('.selectize-control');

      const mentionsSelectizeDropdownForTrix = $trix => mentionsSelectizeForTrix($trix).find('.selectize-dropdown');

      const createMentionsDivForTrix = $trix => $trix.after("<trix-mentions id='trix-mentions-"+  $trix.attr('trix-id') + "'><div class='trix-mentions-position'><input id='trix-mentions-input-" + $trix.attr('trix-id') + "'></input></div></trix-mentions>");

      const createAtButton = $trix => $trix.after("<a id='trix-mentions-button-"+  $trix.attr('trix-id') + "' class='btn btn-primary pull-right m-l-10 trix-actions' href='javascript:;'>@</a>");

      const initializeMentionsSelectize = $trix => $.getJSON($trix.data(MENTIONS_PATH), function(result) {
        return mentionsInputForTrix($trix).selectize({
          create: false,
          valueField: 'id',
          labelField: 'name',
          searchField: 'name',
          sortField: 'name',
          options: result.data,
          selectOnTab: true,
          onInitialize() {
            return this.disable();
          },
          onItemAdd(value, $item) {
            const embed = "<span class='trix-mention'>@" + $item.text() + "</span>";
            const attachment = new Trix.Attachment({
              content: embed,
              'attachment-type': 'trix-mention',
              'user-id': $item.data('value')
            });
            $trix[0].editor.setSelectedRange([$trix.data('last-position') - 1, $trix.data('last-position')]);
            $trix[0].editor.deleteInDirection('forward');
            $trix[0].editor.insertAttachment(attachment);
            $trix[0].editor.setSelectedRange([$trix.data('last-position'), $trix.data('last-position') + 1]);
            $trix[0].editor.insertString(" ");
            return mentionsDivForTrix($trix).hide();
          },
          onBlur() {
            mentionsDivForTrix($trix).hide();
            this.disable();
            $trix.focus();
            if (this.items.length === 0) {
              $trix[0].editor.setSelectedRange([$trix.data('last-position') - 1, $trix.data('last-position')]);
              return $trix[0].editor.deleteInDirection('forward');
            }
          },
          onDropdownOpen($dropdown) {
            const cursorPosition = $trix[0].editor.getClientRectAtPosition($trix[0].editor.getPosition());
            if ((cursorPosition.left + 200) > ($trix.offset().left + $trix.width())) {
              return $dropdown.css('left', ($trix.offset().left + $trix.width()) - (cursorPosition.left + 190));
            }
          },
          onDropdownClose() {
            mentionsDivForTrix($trix).hide();
            mentionsPositioningDivForTrix($trix).css('left', 0);
            return mentionsPositioningDivForTrix($trix).css('top', 0);
          },
          onType(str) {
            const cursorPosition = $trix[0].editor.getClientRectAtPosition($trix[0].editor.getPosition());
            if ((cursorPosition.left + 200) > ($trix.offset().left + $trix.width())) {
              return mentionsSelectizeDropdownForTrix($trix).css('left', ($trix.offset().left + $trix.width()) - (cursorPosition.left + 190));
            }
          }
        });
      });

      const openMentionsSelectize = function($trix, editor) {
        $trix.data('last-position', editor.getPosition());

        const mentionsInput = mentionsInputForTrix($trix);
        mentionsInput[0].selectize.clear();
        mentionsInput[0].selectize.enable();
        mentionsDivForTrix($trix).show();
        mentionsInput[0].selectize.focus();

        const cursorPosition = editor.getClientRectAtPosition(editor.getPosition());
        const mentionsPosition = mentionsPositioningDivForTrix($trix)[0].getBoundingClientRect();

        mentionsPositioningDivForTrix($trix).css('top', cursorPosition.top - mentionsPosition.top - 5);
        return mentionsPositioningDivForTrix($trix).css('left', cursorPosition.left - mentionsPosition.left - 10);
      };


      if (($trix.data(MENTIONS_PATH) != null) && ($trix.data(MENTIONS_PATH).length > 0)) {
        createMentionsDivForTrix($trix);
        initializeMentionsSelectize($trix);
        if (navigator.userAgent.match(/Android/)) {
          createAtButton($trix);
        }
        $("#trix-mentions-button-" + $trix.attr('trix-id')).on('click', function() {
          const trix = $("trix-editor[trix-id=" + $trix.attr('trix-id') + "]")[0];
          const {
            editor
          } = trix;
          const position = editor.getPosition();
          editor.setSelectedRange([position, position]);
          editor.insertString("@");
          return openMentionsSelectize($(trix), editor);
        });

        $trix.on('trix-change', function() {
          const {
            editor
          } = this;
          if (!navigator.userAgent.match(/Android/)) {
            const char = editor.getDocument().toString().charAt(editor.getPosition() - 1);
            if (char === '@') { return openMentionsSelectize($(this), editor); }
          }
        });
        return $trix.on('trix-attachment-add trix-attachment-remove', function() {
          if ($trix.data(MENTIONS_ONLY) === true) {
            const doc = this.editor.getDocument();
            const firstAttachment = doc.getAttachments()[0];
            if ((firstAttachment !== undefined) && (doc.getRangeOfAttachment(firstAttachment)[0] === 0)) {
              $(this).addClass("mentions-only");
              return $(".mentions-only-instructions").removeClass("hidden");
            } else {
              $(this).removeClass("mentions-only");
              return $(".mentions-only-instructions").addClass("hidden");
            }
          }
        });
      }
    }
  });
  Cls.initClass();
  return Cls;
})();
